export default __webpack_public_path__ + "static/media/mic.4d38bb16.svg";